import React from 'react';
import styles from './Ambient.module.css';

// Three fixed, heavily blurred color blobs that drift slowly behind the
// content. Purely decorative, aria-hidden.
export default function Ambient() {
  return (
    <div className={styles.ambient} aria-hidden="true">
      <i />
      <i />
      <i />
    </div>
  );
}
